<div class="auto-tag-process-container">
  <!-- Loading Overlay -->
  @if (loading) {
<div class="loading-overlay">
    <div class="loading-spinner-container">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
      <span class="loading-message">{{loadingMessage}}</span>
    </div>
  </div>
}

  <!-- Header Section -->
  <table class="gt-reclass-table table table-condensed">
    <thead style="white-space: nowrap;">
      <tr>
        <th colspan="16" style="width: 100%;">Auto Tag Process</th>
      </tr>
    </thead>
  </table>

  <br>

  <!-- Tax Year and Scenario -->
  <table class="trans-table">
    <tr>
      <td class="nowrap" style="padding-right: 10px;">Tax Year</td>
      <td style="padding-right: 40px;">
        <select id="FTC_SSSYNC_UD_1" class="form-control"
          [(ngModel)]="selectedTaxYear" style="height: 30px; width: 180px;"
          (ngModelChange)="getScenarioDropDown()">
          <option value="" disabled selected>Select Tax Year</option>
          @for (taxyr of filteredTaxYearData; track $index) {
<option [value]="taxyr.CODE_DISP_DESC">
            {{taxyr.CODE_DISP_DESC}}
          </option>
}
        </select>
      </td>
      @if (showscenario) {
<td class="p-left" style="padding-right: 10px;">Scenario</td>
}
      <td>
        @if (showscenario) {
<select id="FTC_IAPR_CD_12" class="form-control"
          [(ngModel)]="selectedScenario" style="height: 30px; width: 180px;"
          (ngModelChange)="onScenarioChange()"
         >
          <option value="" disabled selected>Select Scenario</option>
          @for (option of scenarioDropDown; track $index) {
<option [value]="option.VALUE">
            {{option.LABEL}}
          </option>
}
        </select>
}
      </td>
    </tr>
  </table>

  <!-- Transaction Types with Toggle -->
  @if (showTransTypes) {
<table class="trans-table types">
    @for (t of trans_types; track $index) {
<tr>
      <td>{{t.GROUP_NAME}}</td>
      <td class="type-toggle">
        <div class="switch-wrapper"
             [class.switch-on]="t.IS_ENABLED"
             [class.switch-off]="!t.IS_ENABLED"
             [class.switch-disabled]="savingGroupKey !== null"
             (click)="toggleTransJob(t)">
          <span class="switch-label">{{ t.IS_ENABLED ? 'On' : 'Off' }}</span>
          <span class="switch-knob"></span>
        </div>
        @if (savingGroupKey === t.GROUP_KEY) {
<i
           class="fa fa-spinner fa-spin saving-spinner"></i>
}
      </td>
    </tr>
}
  </table>
}

  <br>

  <!-- Auto Tag Creation Section -->
  <div class="auto-tag-creation-row">
    <div class="auto-tag-field auto-tag-label-field">
      <span class="auto-tag-section-label">Auto Tag Creation</span>
    </div>

    <div class="auto-tag-field">
      <label>Parent ME(s):</label>
      <ap-dropdown
        id="FTC_AM_CD_22"
        style="width:180px;min-width:180px"
        [selectType]="'multiple'" [enableNgContent]="false"
        [list]="dropdownLists['parentME']" [optionName]="'PARENT_ME_NAME'" [optionValue]="'PARENT_ME_KEY'"
        [title]="'Select Parent ME(s)'" [inputAriaLabel]="'Select Parent ME(s)'" [hideTitleOnInput]="true"
        [showSearchbox]="true" [showSelectAll]="true" [clearSearchKeyword]="true"
        (onFilterResult)="onDropdownFilterResult('parentME', $event)"
        [(ngModel)]="parentME">
      </ap-dropdown>
    </div>

    <div class="auto-tag-field">
      <label>Filing Group:</label>
      <select id="FTC_IAPR_CD_12" class="form-control"
        [(ngModel)]="filingGroup"
        style="height: 36px; width: 180px; line-height: 36px; padding: 6px 12px;"
        (ngModelChange)="getFilingEnityDetails()">
        <option value="" disabled selected>Select Filing Group</option>
        @for (option of filingGroupDropDown; track $index) {
<option [value]="option.VALUE">
          {{option.LABEL}}
        </option>
}
      </select>
    </div>

    <div class="auto-tag-field">
      <label>Filer LE:</label>
      <ap-dropdown
        id="FTC_AM_CD_23"
        style="width:180px;min-width:180px"
        [selectType]="'multiple'" [enableNgContent]="false"
        [list]="dropdownLists['filerLE']" [optionName]="'FILER_LE'" [optionValue]="'FILER_LE_KEY'"
        [title]="'Select Filer LE'" [inputAriaLabel]="'Select Filer LE'" [hideTitleOnInput]="true"
        [showSearchbox]="true" [showSelectAll]="true" [clearSearchKeyword]="true"
        (onFilterResult)="onDropdownFilterResult('filerLE', $event)"
        [(ngModel)]="filerEntity"
        [disabled]="filingEnityDetails.length === 0">
      </ap-dropdown>
    </div>

    <div class="auto-tag-field auto-tag-btn-field">
      <button id="FTC_SSSYNC_UD_9" class="btn btn-info btn-sm" type="button"
        (click)="onAutoTagClick()">
        Auto Tag
      </button>
    </div>
  </div>
</div>

<!-- Confirmation Modal -->
@if (showConfirmModal) {
<div class="confirmation-modal-overlay">
  <gtw-confirmation-modal
    [config]="confirmModalConfig"
    [visible]="true"
    (confirmed)="onConfirmAutoTag()"
    (cancelled)="onCancelConfirm()"
    (closed)="onCancelConfirm()">
  </gtw-confirmation-modal>
</div>
}
